import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './assets/libs/boxicons-2.1.1/css/boxicons.min.css';
import './scss/App.scss';
import Dashboard from './pages/Dashboard';
import MainLayout from './layout/MainLayout';
import Analytics from './pages/Analytics';
import CategoryForm from './pages/CategoryForm';
import ServicesForm from './pages/ServicesForm';
import RegistrationForm from './pages/RegistrationForm';
import ViewReport from './pages/ViewReport';
import LoginForm from './pages/Login/LoginForm';
import ProviderLoginPage from './pages/ProviderLogin/LoginForm';
import BookingReport from './pages/BookingReport';
import CustomerReport from './pages/CustomerReport';
import ProviderProfile from './pages/ProviderProfile';
import ProvidersAvailability from './pages/ProvidersAvailability';
import AssignOrders from './pages/AssignOrders';
import CustomToastContainer from './components/ToastMessage/ToastContainer';
import { RingLoader } from 'react-spinners';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const encodedId = sessionStorage.getItem('admin_id');
    return !!encodedId;
  });

  const [isProviderAuthenticated, setIsProviderAuthenticated] = useState(() => {
    const providerId = sessionStorage.getItem('provider_id');
    return !!providerId;
  });

  const [loading, setLoading] = useState(true);

  const handleAdminLogin = (adminId) => {
    const encodedId = btoa(adminId); // Encoding for security
    sessionStorage.setItem('admin_id', encodedId);
    setIsAuthenticated(true);
  };

  const handleProviderLogin = (providerId) => {
    const encodedProviderId = btoa(providerId); // Encoding for security
    sessionStorage.setItem('provider_id', encodedProviderId);
    setIsProviderAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setIsProviderAuthenticated(false);
    sessionStorage.removeItem('admin_id');
    sessionStorage.removeItem('provider_id');
    window.location.href = isProviderAuthenticated ? '/provider-login' : '/login';
  };

  const isAuthenticatedUser = isAuthenticated || isProviderAuthenticated;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (loading) {
    return (
      <div className="loading-spinner">
        <h4>Please Wait.....</h4>
        <RingLoader color="#3498db" loading={loading} size={50} />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <CustomToastContainer />
      <Routes>
        <Route
          path="/login"
          element={isAuthenticatedUser ? <Navigate to="/" /> : <LoginForm onLogin={handleAdminLogin} />}
        />
        <Route
          path="/provider-login"
          element={isAuthenticatedUser ? <Navigate to="/" /> : <ProviderLoginPage onLogin={handleProviderLogin} />}
        />
        <Route
          path="/"
          element={
            isAuthenticatedUser ? (
              <MainLayout onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="servicesform" element={<ServicesForm />} />
          <Route path="customersreport" element={<CustomerReport />} />
          <Route path="servicecategory" element={<CategoryForm />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="servicereg" element={<RegistrationForm />} />
          <Route path="bookingreport" element={<BookingReport />} />
          <Route path="AssignOrders" element={<AssignOrders />} />
          <Route path="providerprofile" element={<ProviderProfile />} />
        </Route>
        <Route path="view-report" element={<ViewReport />} />
        <Route path="service-providers" element={<ProvidersAvailability />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
